export default "/images/male.svg?e297e84d5e32d286e5e31cb5b7f65371";